<kendo-grid [data]="GaugePadElements$ | async" (edit)="editHandler($event)" (cancel)="cancelHandler($event)" (save)="saveHandler($event)"
    (remove)="removeHandler($event)" (add)="addHandler($event)">
    <ng-template kendoGridToolbarTemplate>
        <button kendoGridAddCommand>Add new</button>
        <span class="title">Gauge Protection Elements</span>
    </ng-template>
    <kendo-grid-column field="id" [hidden]="true">
        <ng-template kendoGridCellTemplate let-dataItem let-formGroup="formGroup" let-column="column">
            <input [formControl]="formGroup.get(column.field)">
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="sapMaterialNumber" [hidden]="true">
        <ng-template kendoGridCellTemplate let-dataItem let-formGroup="formGroup" let-column="column">
            <input [formControl]="formGroup.get(column.field)">
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="type" title="Type">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-column="column">
            <kendo-dropdownlist [data]="GaugeElements" [formControl]="formGroup.get(column.field)" valueField="value"
                textField="value" [valuePrimitive]="true">   
            </kendo-dropdownlist>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="quantity" title="Qty" [width]="50" editor="numeric">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-column="column">
            <kendo-numerictextbox [formControl]="formGroup.get(column.field)" [min]="0" [step]="1" [decimals]="0"
                [spinners]="false"></kendo-numerictextbox>  
        </ng-template> </kendo-grid-column>
    <kendo-grid-command-column [width]="125">
        <ng-template kendoGridCellTemplate let-isNew="isNew">
                <button kendoGridEditCommand [primary]="true">Edit</button>
                <button kendoGridRemoveCommand>Remove</button>
                <button kendoGridSaveCommand [disabled]="formGroup.invalid" *ngIf="formGroup"><span class="k-icon k-font-icon k-i-save"></span></button>
                <button kendoGridCancelCommand>{{ isNew ? "Discard changes" : "Cancel" }}</button>
        </ng-template>
    </kendo-grid-command-column>
</kendo-grid>